import { IconComponent, ButtonComponent, IconButtonComponent } from '@mode/capra';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileExportDomain } from '@mode/shared/contract-common';

/**
 * Placeholder component, delete or remake if needed
 */
@Component({
  selector: 'mode-file-exports-ui-list-item',
  standalone: true,
  imports: [CommonModule, IconComponent, ButtonComponent, IconButtonComponent],
  templateUrl: './file-exports-ui-list-item.component.html',
  styleUrls: ['./file-exports-ui-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileExportsUiListItemComponent implements OnChanges {
  @Input() status: FileExportDomain.ExportStatus | undefined;
  @Input() id!: string;
  @Input() title: string | undefined;
  @Output() downloadCsv = new EventEmitter<string>();
  @Output() retryDownloadCsv = new EventEmitter<string>();
  @Output() deleteCsv = new EventEmitter<string>();

  iconName: 'icon-check-large' | 'icon-close' | 'icon-refresh' = 'icon-refresh';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['status']) {
      switch (changes['status'].currentValue) {
        case FileExportDomain.ExportStatus.Success:
          this.iconName = 'icon-check-large';
          break;
        case FileExportDomain.ExportStatus.Error:
          this.iconName = 'icon-close';
          break;
        default:
          this.iconName = 'icon-refresh';
          break;
      }
    }
  }

  onRetryExportClick(id: string) {
    this.retryDownloadCsv.emit(id);
  }

  onDownloadClick(id: string) {
    this.downloadCsv.emit(id);
  }

  onDeleteClick(id: string) {
    this.deleteCsv.emit(id);
  }
}
